/*
 * SPDX-FileCopyrightText: 2023 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

export const configurator = {
  configurator: {
    header: {
      consistent: 'Consistente',
      complete: 'Íntegro',
      configId: 'IDENTIFICACIÓN de configuración',
      toconfig: 'Configurar',
      editConfiguración: 'Editar configuración',
      displayConfiguración: 'Configuración de la pantalla',
      resolveIssues: 'Resolver problemas',
      resolveIssue: 'Resolver problema',
      resolveConflictos: 'Resolver conflictos',
      conflictWarning: 'El conflicto debe resolverse para que continúe',
      updateMessage: 'La configuración se está actualizando en segundo plano',
      conflictsResolved: 'Los conflictos se han resuelto',
      mostrarMore: 'Mostrar más',
      mostrarLess: 'Mostrar menos',
      items: '{{count}} artículo',
      items_other: '{{count}} artículos',
      mostrar: 'mostrar',
      esconder: 'esconder',
      multipleWarnings: 'Hay múltiples advertencias.',
      reviewWarnings: 'Revise estas advertencias',
      multipleErrors: 'Hay varios errores.',
      reviewErrors: 'Revisión de estos errores',
      kbKeyName: 'Nombre de Kb',
      kbKeyLogsys: 'Sistema lógico Kb',
      kbKeyVersion: 'Versión Kb',
      kbKeyBuildNr: 'Número de compilación de Kb',
    },
    tabBar: {
      configuration: 'Configuración',
      overview: 'Visión general',
    },
    notificationBanner: {
      numberOfIssues: '{{count}} El problema debe resolverse antes de finalizar la compra.',
      numberOfIssues_other:
        '{{count}} Los problemas deben resolverse antes de finalizar la compra.',
      numberOfConflictos: '{{count}} El conflicto debe resolverse antes de finalizar la compra.',
      numberOfConflictos_other:
        '{{count}} Los conflictos deben resolverse antes de realizar el pago.',
    },
    attribute: {
      id: 'IDENTIFICACIÓN',
      quantity: 'Cantidad',
      caption: 'Atributos',
      notSupported: 'No se admite el tipo de atributo.',
      requiredAttribute: '{{param}} requerido',
      defaultRequiredMessage: 'Introduzca un valor para el campo obligatorio',
      singleEscogerRequiredMessage: 'Seleccione un valor',
      singleEscogerAgregaritionalRequiredMessage: 'Seleccione o introduzca un valor',
      multiEscogerRequiredMessage: 'Seleccione uno o más valores',
      // TODO (CXSPA-3392): `wrongNumericFormat` is deprecated and will be removed for the next major release
      wrongNumericFormat:
        'Formato incorrecto, este atributo numérico debe ingresarse de acuerdo con el patrón {{pattern}}',
      wrongNumericFormatMessage:
        'Introduzca el número en el siguiente formato: {{pattern}}',
      wrongIntervalFormat: 'Introduzca un valor dentro de los límites indicados',
      deselectionNotPossible:
        'Agregue un producto diferente antes de quitar este',
      dropDownEscogerMsg: 'Hacer una selección',
      noOptionEscogeredMsg: 'No hay ninguna opción seleccionada',
      notVisibleAttributeMsg: 'Este atributo no es visible para el usuario',
    },
    button: {
      previous: 'Anterior',
      next: 'Próximo',
      back: 'Atrás',
      más: 'más',
      menos: 'menos',
      deselect: 'Deseleccionar',
      select: 'Escoger',
      add: 'Agregar',
      remove: 'Eliminar',
      exit: 'Salida Configuración',
      exitMobile: 'Salida',
      cancelConfiguración: 'Cancelar Configuración',
      cancelConfiguraciónMobile: 'Cancelar',
      filterOverview: 'Filtro',
      filterOverviewWithCount: 'Filtro ({{numAppliedFilters}})',
    },
    icon: {
      groupÍntegro: 'Íntegro',
      groupIncompleto: 'Incompleto',
      groupConflicto: 'Conflicto',
      subgroup: 'tiene subgrupos',
    },
    priceSummary: {
      basePrice: 'Precio base',
      selectedOptions: 'Opciones de Escogered',
      totalPrice: 'Total',
      totalPricePerItem: 'Total por artículo',
    },
    addToCart: {
      button: 'Agregar a la cesta',
      buttonAfterAgregarToCart: 'Continuar al carrito',
      buttonUpdateCart: 'Hecho',
      buttonDisplayOnly: 'Hecho',
      buttonCerrar: 'Cerrar',
      confirmation: 'Configuración se ha añadido al carrito',
      confirmationUpdate: 'El carrito se ha actualizado con la configuración',
      quantity: 'Cantidad',
    },
    overviewForm: {
      noAttributeHeader: 'Sin resultados',
      noAttributeText: 'Eliminar filtro(s) para ver el contenido general de Visión',
      itemPrice: 'Precio del artículo',
    },
    overviewSidebar: {
      menu: 'Menú',
      filter: 'Filtro',
    },
    overviewFiltro: {
      title: 'Escoger Filtros',
      byOption: 'Filtro por opción',
      byGroup: 'Filtro por Grupo',
      byPrice: 'Opciones relevantes para el precio',
      myEscogerions: 'Mis Escogerions',
      removeAll: 'Eliminar All',
      removeAllFiltros: 'Eliminar All Filtros',
      removeByPrice: 'Eliminar Price-Relevant Filtro',
      removeMyEscogerions: 'Eliminar Mis Escogerions Filtro',
      removeByGroup: 'Eliminar Group Filtro for group {{group}}',
    },
    group: {
      general: 'General',
      conflictHeader: 'Resolver conflictos',
      conflictGroup: 'Conflicto por {{attribute}}',
    },
    conflict: {
      suggestionTitle: 'Sugerencia {{number}}:',
      suggestionText: 'Change value for "{{ attribute }}"',
      viewConflictoDetails: 'Conflicto Detectado - Ver Detalles',
      conflictDetected: 'Conflicto detectado',
      viewConfiguraciónDetails: 'View In Configuración',
    },
    restartDialog: {
      title: 'Unfinished Configuración',
      description:
        'There is an unfinished configuration from a previous session. Would you like to resume or start a new configuration?',
      restartButton: 'Empezar de nuevo',
      resumeButton: 'Reanudar',
    },
    a11y: {
      configureProduct: 'Configurar producto',
      cartEntryBundleInfo: 'Hay un elemento ',
      cartEntryBundleInfo_other: 'Hay {{items}} artículos ',
      cartEntryBundleName: 'Artículo {{ name }}',
      cartEntryBundleNameWithQuantity:
        'Artículo {{ name }} cantidad de artículo {{quantity}}',
      cartEntryBundleNameWithPrice: 'Artículo {{ name }} item price {{price}}',
      cartEntryBundle:
        'Artículo {{ name }} precio del artículo {{price}} cantidad del artículo {{quantity}}',
      cartEntryInfoIntro:
        'El producto tiene los siguientes atributos y valores seleccionados:',
      cartEntryInfo: 'El atributo {{ attribute }} tiene el valor seleccionado {{value}}',
      nameOfAttribute: 'Nombre del atributo',
      valueOfAttribute: 'Valor del atributo {{ attribute }}',
      forAttribute: '{{ value }} para el atributo {{ attribute }}',
      valueOfAttributeFull: 'Valor {{ value }} del atributo {{ attribute }}',
      valueOfAttributeFullWithPrice:
        'Valor {{ value }} del atributo {{ attribute }}, Surcharge {{ price }}',
      selectedValueOfAttributeFull:
        'Valor de Escogered {{ value }} del atributo {{ attribute }}',
      selectedValueOfAttributeFullWithPrice:
        'Valor de Escogered {{ value }} del atributo {{ attribute }}, Surcharge {{ price }}',
      readOnlyValueOfAttributeFullWithPrice:
        'Valor de solo lectura {{ value }} del atributo {{ attribute }}, Recargo {{ price }}',
      readOnlyValueOfAttributeFull:
        'Valor de solo lectura {{ value }} del atributo {{ attribute }}',
      valueOfAttributeBlank: 'Valor del atributo {{ attribute }} is blank',
      value: 'Valor {{ value }}',
      attribute: 'Atributo {{ attribute }}',
      requiredAttribute: 'El atributo {{param}} es obligatorio',
      listOfAtributosAndValues: 'Lista de atributos y sus valores:',
      editAtributosAndValues: 'Edite los valores de los atributos:',
      group: '{{ group }} grupo de atributos',
      itemOfAttributeEscogered:
        'Se selecciona el elemento {{ item }} del atributo {{ attribute }}. {{ itemIndex }} de {{ itemCount }}',
      itemOfAttributeEscogeredWithPrice:
        'Se selecciona el elemento {{ item }} del atributo {{ attribute }}, Recargo {{ price }}. {{ itemIndex }} de {{ itemCount }}',
      itemOfAttributeEscogeredPressToUnselect:
        'Se selecciona el elemento {{ item }} del atributo {{ attribute }}. Presione el botón para anular la selección. {{ itemIndex }} de {{ itemCount }}',
      itemOfAttributeEscogeredPressToUnselectWithPrice:
        'Se selecciona el elemento {{ item }} del atributo {{ attribute }}, Recargo {{ price }} Presione el botón para anular la selección. {{ itemIndex }} de {{ itemCount }}',
      itemOfAttributeUnselected:
        'El elemento {{ item }} del atributo {{ attribute }} no está seleccionado. Presione el botón para seleccionar. {{ itemIndex }} de {{ itemCount }}',
      itemOfAttributeUnselectedWithPrice:
        'El elemento {{ item }} del atributo {{ attribute }} no está seleccionado, Recargo {{ price }}. Presione el botón para seleccionar. {{ itemIndex }} de {{ itemCount }}',
      selectNoItemOfAttribute:
        'Para seleccionar ningún elemento para el atributo {{ attribute }} pulse el botón. {{ itemIndex }} de {{ itemCount }}',
      itemOfAttribute: 'Elemento de atributo {{ attribute }}',
      itemOfAttributeFull: 'Elemento {{ item }} del atributo {{ attribute }}',
      itemOfAttributeFullWithPrice:
        'Elemento {{ item }} of tributo {{ attribute }}, Recargo {{ price }}',
      itemOfAttributeFullWithQuantity:
        'Elemento {{ item }} of tributo {{ attribute }}, Cantidad {{ quantity }}',
      itemOfAttributeFullWithPriceAndQuantity:
        'Elemento {{ item }} of tributo {{ attribute }}, Cantidad {{ quantity }}, Surcharge {{ price }}',
      itemDescription: 'Descripción del artículo {{ item }}',
      listbox: 'Cuadro de lista con valores {{ count }}.',
      valueSurcharge: 'Recargo por valor',
      conflictDetected:
        'Conflicto detected! Check the conflicts at top of group list.',
      conflictsInConfiguración:
        'Hay conflictos en la configuración. Número de conflictos: {{ numberOfConflicts }}, Escoger para más detalles.',
      listOfGroups: 'Lista de grupos',
      inListOfGroups: 'Estás en la lista de grupos',
      groupName: 'Grupo {{ group }}',
      groupAtrás: 'Estás en un subgrupo. Escoger para volver.',
      conflictAtrás:
        'Estás en el solucionador de conflictos. Escoger para volver atrás o seleccionar las siguientes pestañas para resolver conflictos.',
      iconConflicto: 'El grupo tiene conflictos.',
      iconIncompleto: 'El grupo tiene atributos obligatorios sin valores seleccionados.',
      iconÍntegro: 'El grupo está completo.',
      iconSubGroup: 'El grupo tiene un subgrupo.',
      next: 'Vaya al siguiente grupo.',
      previous: 'Vaya al grupo anterior.',
      showMoreProductInfo:
        'Mostrar más información para el producto {{ product }} o continuar con la configuración.',
      showLessProductInfo:
        'Mostrar menos información para el producto {{ product }} o continuar con la configuración.',
      productName: 'Nombre del producto',
      productCode: 'Código de producto',
      productDescription: 'Descripción del producto',
      kbKeyName: 'Nombre de Kb {{name}}',
      kbKeyLogsys: 'Sistema lógico Kb {{logsys}}',
      kbKeyVersion: 'Versión Kb {{version}}',
      kbKeyBuildNr: 'Número de compilación de Kb {{number}}',
      configurationPage: 'Se encuentra en la página de configuración.',
      configurationPageLink: 'Vaya a la página de configuración.',
      overviewPage:
        'Se encuentra en la página de información general. Compruebe los atributos y sus valores seleccionados con el modo de lectura de su lector de pantalla.',
      overviewPageLink: 'Vaya a la página de información general de la configuración.',
      navigateToConflicto:
        'Siga el enlace para obtener más detalles sobre el conflicto del atributo {{ attribute }}.',
      numericIntervalStandard:
        'Introduzca un valor entre {{ minValue }} y {{ maxValue }}',
      numericIntervalStandardOpen: '(Los puntos de conexión no están incluidos)',
      numericIntervalStandardLowerEndpointNotIncluded:
        '(El criterio de valoración inferior no está incluido)',
      numericIntervalStandardUpperEndpointNotIncluded:
        '(El criterio de valoración superior no está incluido)',
      numericInfiniteIntervalMinValueIncluded:
        'Introduzca un valor mayor o igual que {{ value }}',
      numericInfiniteIntervalMinValue: 'Introduzca un valor mayor que {{ value }}',
      numericInfiniteIntervalMaxValueIncluded:
        'Introduzca un valor menor o igual que {{ value }}',
      numericInfiniteIntervalMaxValue: 'Introduzca un valor inferior a {{ value }}',
      numericIntervalSingleValue: 'Enter {{ value }}',
      combinedIntervalsText: '{{ combinedInterval }} o {{ newInterval }}',
      additionalValue: 'También puede introducir un valor adicional.',
      addToCartPrices:
        'Precio base {{basePrice}}, Opciones de Escogered {{selectedOptions}}, Total Price {{totalPrice}}',
      filterOverview: 'Abrir el menú de filtro de información general de configuración',
      filterOverviewWithCount:
        'Abra el menú de filtros de resumen de configuración - {{numAppliedFilters}} filtros activos',
      closeFiltroMenú:
        'Cierre el menú de filtros de la descripción general de la configuración y aplique los filtros seleccionados',
      filterOverviewByPrice:
        'Resumen de la configuración del filtro por opciones relevantes para el precio',
      filterOverviewByMySelections:
        'Descripción general de la configuración del filtro por sus selecciones',
      filterOverviewByGroup:
        'Descripción general de la configuración del filtro por grupo {{groupName}}',
      closeConflictoSolverModal: 'Cerrar conflict solver modal',
      closeRestartDialog:
        'Cerrar the "Unfinished Configuración" dialog and navigate back to the product details page',
    },
    variantCarousel: {
      title: 'Versiones preconfiguradas',
    },
  },
};
